import { FC } from 'react';
import { observer } from 'mobx-react';
import { cashbackStore } from '../../store/cashbackStore';
import { BRANCHES_SELECTION } from '../../types/cashback';
import Text, { TEXT } from '~/view/components/Text/Text';
import { localeStore } from '~/mobx/localesStore';
import { TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import TabPicker from '~/view/components/Controls/Pickers/TabPicker/TabPicker';
import BranchesModalOpen from '~/view/containers/Modals/BranchesModal/components/BranchesModalOpen/BranchesModalOpen';
import { BranchesModalProfile, IBranchesModalItem } from '~/view/containers/Modals/BranchesModal/BranchesModal';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';
import './style.scss';

const CashbackBranches: FC = observer((): JSX.Element => {
  const branchesSelectionOptions: IPickerOption[] = [
    { label: localeStore.t(BRANCHES_SELECTION.ALL), value: BRANCHES_SELECTION.ALL },
    { label: localeStore.t(BRANCHES_SELECTION.INCLUDED), value: BRANCHES_SELECTION.INCLUDED },
  ];

  const handleBranchesSelectionChange = (value: BRANCHES_SELECTION) => {
    cashbackStore.changeCashback({ branchesSelection: value, branches: [] });
  };

  const handleBranchesChange = (branches: IBranchesModalItem[]) => {
    cashbackStore.changeCashback({ branches });
  };

  // TOFIX case - branch was deleted during edit cashback
  // useEffect(() => {
  //   const notExistedBranches = cashbackStore.cashback.branches.filter(
  //     ({ id }) => !branchesModalStore.pagination.data.find((branch) => branch.id === id)
  //   );

  //   if (branchesModalStore.pagination.data.length > 0 && notExistedBranches.length > 0) {
  //     const existedBranches = cashbackStore.cashback.branches.filter(
  //       ({ id }) => !!branchesModalStore.pagination.data.find((branch) => branch.id === id)
  //     );
  //     handleBranchesChange(existedBranches);
  //   }
  // }, [cashbackStore.cashback.branches.length, branchesModalStore.pagination.data.length]);

  const selectedBranches: IBranchesModalItem[] = cashbackStore.cashback.branches.map((branch) => ({ ...branch, status: 1 }));

  return (
    <div className="d-flex flex-column mt-4">
      <Text
        text={localeStore.t('cashback_for_branches_hdr')}
        type={TEXT.BLOCK_HEADER}
        tooltip={{ message: 'cashback_for_branches_header_hint', position: TOOLTIP_POSITION.PORTAL }}
      />
      <div className="d-flex gap-15 mt-2">
        <TabPicker options={branchesSelectionOptions} value={cashbackStore.cashback.branchesSelection} onChange={handleBranchesSelectionChange} />
        {cashbackStore.cashback.branchesSelection === BRANCHES_SELECTION.INCLUDED ? (
          <BranchesModalOpen
            selectedBranches={selectedBranches}
            className="cashback-branches__picker"
            isMulti
            highlightUnavailable
            unavailableTooltipMessage="cashback_branch_is_inactive_err"
            profileNamesToShow={[BranchesModalProfile.FRANCHISE]}
            onSave={handleBranchesChange}
          />
        ) : null}
      </div>
    </div>
  );
});

export default CashbackBranches;
